import type { WidgetConfig } from '@cartiq/shared';

interface Props {
  cartCount: number;
  hasCart: boolean;
  onClick: () => void;
  unreadCount?: number;
  widgetConfig: WidgetConfig;
}

export function ChatFab({
  cartCount,
  hasCart,
  onClick,
  unreadCount = 0,
  widgetConfig,
}: Props) {
  const onLeft = widgetConfig.position === 'bottom-left';

  return (
    <button
      onClick={onClick}
      aria-label={`Open ${widgetConfig.launcherLabel}`}
      className={`cartiq-fab group fixed z-50 flex h-14 items-center justify-center gap-2.5 rounded-full border border-white/20 px-4 text-white shadow-[0_12px_36px_rgba(15,23,42,0.24)] transition-all hover:-translate-y-0.5 hover:shadow-[0_16px_42px_rgba(15,23,42,0.28)] active:translate-y-0 active:scale-[0.98] ${
        onLeft ? 'left-4 sm:left-6' : 'right-4 sm:right-6'
      } ${widgetConfig.showLauncherLabel ? '' : 'w-14 px-0'}`}
      style={{
        backgroundColor: 'var(--brand-accent)',
        bottom: `${widgetConfig.bottomOffset}px`,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="shrink-0 transition-transform group-hover:scale-105"
      >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>

      {widgetConfig.showLauncherLabel && (
        <span className="max-w-[calc(100vw-7rem)] truncate whitespace-nowrap text-sm font-semibold">
          {widgetConfig.launcherLabel}
        </span>
      )}

      {hasCart && (
        <span className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-error px-1 text-[10px] font-bold text-white ring-2 ring-white">
          {cartCount}
        </span>
      )}

      {unreadCount > 0 && !hasCart && (
        <span className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-error px-1 text-[10px] font-bold text-white ring-2 ring-white">
          {unreadCount}
        </span>
      )}
    </button>
  );
}

export default ChatFab;
